import * as React from "react";
import { withTranslation } from "react-i18next";
class RelativeTimeClass extends React.Component {
    interval = null;
    componentDidMount() {
        this.interval = setInterval(() => {
            this.forceUpdate();
        }, 2000);
    }
    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
    render() {
        const { timestamp, t, showErrorForPastTimes } = this.props;
        let className = "";
        if (showErrorForPastTimes && (Date.now() > timestamp)) {
            className = "error-text";
        }
        return (React.createElement("span", { className: className }, t ? t("relative", { value: timestamp }) : ""));
    }
}
export const RelativeTime = withTranslation()(RelativeTimeClass);
//# sourceMappingURL=RelativeTime.js.map